import {
  IMAGES_FAILURE,
  IMAGES_SUCCESS,
  IMAGES_REQUEST,
  IMAGE_UPLOAD_SUCCESS,
  IMAGE_UPLOAD_FAILURE,
  IMAGE_UPLOAD_REQUEST,
} from '../actions/images';

const intialState = {
  urls: [],
  readError: null,
  isReading: false,
  isUploading: false,
  uploadError: null,
};

export default (state = intialState, action) => {
  const { payload = {} } = action;
  const { error, urls, url } = payload;

  switch(action.type) {
    case IMAGES_REQUEST:
      return { ...state, isReading: true, readError: null };
    case IMAGES_FAILURE:
      return { ...state, urls: [], isReading: false, readError: error };
    case IMAGES_SUCCESS:
      return { ...state, urls: [...urls], isReading: false, readError: null };
    case IMAGE_UPLOAD_REQUEST:
      return { ...state, isUploading: true, uploadError: null };
    case IMAGE_UPLOAD_FAILURE:
      return { ...state, isUploading: false, uploadError: error };
    case IMAGE_UPLOAD_SUCCESS:
      return { ...state, urls: [...state.urls, url ], isUploading: false, uploadError: null };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/images.js